import { apiContactFormSubmitRequested } from '../../api/contact/submitContactFormApi';
import submitContactFormApiSaga from '../api/contact/submitContactFormApiSaga';
import { submitContactFormRequested } from '../../contact/ContactSlice';
import submitContactFormSaga from './submitContactFormSaga';
import { takeLatest } from 'typed-redux-saga';

function* contactSaga(): Generator {
  yield* takeLatest(submitContactFormRequested.type, submitContactFormSaga);
  yield* takeLatest(apiContactFormSubmitRequested.type, submitContactFormApiSaga);
}

export default contactSaga;
